import type { TokenClaims } from "@/types/token"

export function decodeToken(token: string): TokenClaims | null {
  try {
    const parts = token.split(".")
    if (parts.length !== 3) return null

    const base64 = parts[1]!.replace(/-/g, "+").replace(/_/g, "/")
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    )

    return JSON.parse(jsonPayload) as TokenClaims
  } catch {
    return null
  }
}

export function getUsernameFromToken(token: string): string | null {
  const username = decodeToken(token)?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"]
  return username ? username.toLowerCase() : null
}

export function extractTaxiTeamFromToken(token: string): { name: string; code: string } | null {
  const claims = decodeToken(token)
  if (!claims?.TaxiTeamName || !claims.TaxiTeamCode) return null
  return { name: claims.TaxiTeamName, code: claims.TaxiTeamCode }
}

export function extractCompanyIdFromToken(token: string): string | null {
  return decodeToken(token)?.CompanyId || null
}

// Expiry in epoch milliseconds, or null when the token has no exp claim (never expires)
export function getTokenExpiryMs(token: string): number | null {
  const exp = decodeToken(token)?.exp
  return typeof exp === "number" ? exp * 1000 : null
}
